export enum TemplateType {
  EMAIL = 'EMAIL',
  POSITION = 'POSITION',
  OFFER = 'OFFER'
}

export interface Template {
  __typename?: string;
  id?: string;
  name?: string;
  text?: string;
  text2?: string;
  type?: TemplateType;
  branch?: string;
}
